<template>
  <div class="page-wrapper auth">
    <div class="page-inner">
      <div class="page-content-wrapper bg-transparent m-0">
        <div class="height-10 w-100 shadow-lg px-4" style="background-color: #015196;">
          <div class="d-flex align-items-center container p-0 h-100">
            <div class="d-flex align-items-center">
              <div>
                <span style="font-family: 'SF Fourche Regular', sans-serif; font-size: 20px; color: white; line-height: 1.2;">
                  {{ $t('common.drc') }}
                </span>
                <br>
                <div class="d-flex align-items-center">
                  <img src="/estamp-portal/assets/img/DrcFlagLogo.jpg" alt="DRC Flag Logo" style="max-width: 50px; margin-right: 10px;">
                  <span style="font-family: 'SF Fourche Regular', sans-serif; font-size: 16px; color: white;">
                    {{ $t('common.ministry') }}
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center ml-auto">
              <language-switcher />
              <a href="/estamp-portal/#/login" class="btn-link text-white fw-500 ml-4">
                {{ $t('common.verifyUIM') }}
              </a>
              <a href="/estamp-portal/#/login" class="btn-link text-white fw-500 ml-3">
                {{ $t('auth.login') }}
              </a>
            </div>
          </div>
        </div>

        <div class="flex-1" style="background: url(/estamp-portal/assets/img/svg/pattern-1.svg) no-repeat center bottom fixed; background-size: cover;">
          <div class="container">
            <div class="row">
              <div class="col-xl-12">
                <h2 class="fs-xxl fw-500 text-center">
                  {{ $t('registration.stakeholderRegistration') }}
                </h2>
              </div>

              <div class="col-xl-12 ml-auto mr-auto">
                <div class="card p-4 rounded-plus bg-faded">
                  <DxLoadPanel :close-on-outside-click="true" :visible="false" />
                  <vue-good-wizard ref="wizard" :steps="steps" :onNext="nextClicked" :onBack="backClicked">
                    <div slot="page1">
                      <form class="" @submit.prevent="onSubmit" :disabled="loading">
                        <OrganizationDetailsForm ref="form0" :form-data="formData0" label-mode="floating">
                          <DxGroupItem :col-count="2" css-class="first-group" :caption="$t('registration.organizationDetails')">
                            <DxSimpleItem data-field="organization_Name">
                              <dx-label :text="$t('registration.organizationName')" />
                              <dx-required-rule :message="$t('registration.organizationNameRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="company_Registration_No">
                              <dx-label :text="$t('registration.companyRegistrationNo')" />
                              <dx-required-rule :message="$t('registration.companyRegistrationNoRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="company_National_Identification">
                              <dx-label :text="$t('registration.companyNationalId')" />
                              <dx-required-rule :message="$t('registration.companyNationalIdRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sales_Tax_No">
                              <dx-label :text="$t('registration.salesTaxNo')" />
                              <dx-required-rule :message="$t('registration.salesTaxNoRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="mfg_Product_Type_Id" :label="{ text: $t('registration.mfgProductType') }" editor-type="dxSelectBox" :editor-options="{
                              dataSource: MFGProductTypeOptions,
                              displayExpr: 'Name',
                              valueExpr: 'Id',
                              searchEnabled: true,
                              onValueChanged: handleMFGProductType
                            }" :validation-rules="[{ type: 'required', message: $t('registration.mfgProductTypeRequired') }]" />
                            <DxSimpleItem data-field="organization_Type_Id" :label="{ text: $t('registration.organizationType') }" editor-type="dxSelectBox" :editor-options="{
                              dataSource: OrganizationTypeOptions,
                              displayExpr: 'Name',
                              valueExpr: 'Id',
                              searchEnabled: true,
                              onValueChanged: handleOrganizationType
                            }" :validation-rules="[{ type: 'required', message: $t('registration.organizationTypeRequired') }]" />
                            <DxSimpleItem data-field="company_Physical_Address_Hq">
                              <dx-label :text="$t('registration.companyPhysicalAddressHq')" />
                              <dx-required-rule :message="$t('registration.companyPhysicalAddressHqRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="company_Occ_Certification" :label="{ text: $t('registration.companyOccCertification') }" editor-type="dxSelectBox" :editor-options="{
                              dataSource: CompanyOccCertificationOptions,
                              displayExpr: 'Name',
                              valueExpr: 'Id',
                              searchEnabled: true,
                              onValueChanged: handleCompanyOccCertificationOptions
                            }" :validation-rules="[{ type: 'required', message: $t('registration.companyOccCertificationRequired') }]" />
                          </DxGroupItem>
                        </OrganizationDetailsForm>
                      </form>
                    </div>
                    <div slot="page2">
                      <form class="" @submit.prevent="onSubmit" :disabled="loading">
                        <PrimaryContactForm ref="form1" :form-data="formData1" label-mode="floating">
                          <DxGroupItem :col-count="4" css-class="title-with-line" :caption="$t('registration.primaryContact')">
                            <DxSimpleItem data-field="pr_First_Name">
                              <dx-label :text="$t('registration.firstName')" />
                              <dx-required-rule :message="$t('registration.firstNameRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Last_Name">
                              <dx-label :text="$t('registration.lastName')" />
                              <dx-required-rule :message="$t('registration.lastNameRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Title">
                              <dx-label :text="$t('registration.title')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Position">
                              <dx-label :text="$t('registration.position')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Email_Address">
                              <dx-label :text="$t('registration.emailAddress')" />
                              <dx-required-rule :message="$t('registration.emailAddressRequired')" />
                              <dx-email-rule :message="$t('registration.emailInvalid')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="Pr_Confirm_Email">
                              <dx-label :text="$t('registration.confirmEmail')" />
                              <dx-required-rule :message="$t('registration.confirmEmailRequired')" />
                              <DxCompareRule :comparison-target="primaryEmailComparison" :message="$t('registration.emailMismatch')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Phone" editor-type="dxTextBox" :editor-options="phoneOptions">
                              <dx-label :text="$t('registration.primaryPhone')" />
                              <dx-required-rule :message="$t('registration.primaryPhoneRequired')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Ext">
                              <dx-label :text="$t('registration.ext')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Phone_Type_Id" :label="{ text: $t('registration.phoneType') }" editor-type="dxSelectBox" :editor-options="{
                              dataSource: PhoneTypeOptions,
                              displayExpr: 'Name',
                              valueExpr: 'Id',
                              searchEnabled: true,
                              onValueChanged: handlePhoneType
                            }" :validation-rules="[{ type: 'required', message: $t('registration.phoneTypeRequired') }]" />
                          </DxGroupItem>
                          <DxGroupItem :caption="$t('registration.organizationDocuments')" :col-count="1">
                            <DxSimpleItem name="UIMForecastGrid">
                              <template #default>
                                <DxDataGrid ref="OrganizationDocumentsRef" id="grid-container1" :show-borders="true"
                                  :data-source="OrganizationDocumentsData" :row-alternation-enabled="true"
                                  :hover-state-enabled="true" :selection="{ mode: 'multiple' }"
                                  :column-hiding-enabled="true" @row-inserted="onSaveDocument($event)" key-expr="Id">
                                  <DxEditing :allow-deleting="true" :allow-adding="true" mode="form"></DxEditing>
                                  <DxColumn :caption="$t('registration.documentName')" data-field="Doc_Name">
                                    <DxRequiredRule />
                                  </DxColumn>
                                  <DxColumn data-field="Doc_Type" :caption="$t('registration.documentType')">
                                    <DxLookup :data-source="DocTypeOptions" value-expr="Id" display-expr="Name" />
                                    <DxRequiredRule />
                                  </DxColumn>
                                  <DxColumn data-field="Doc_File" :caption="$t('registration.document')" :allow-sorting="false" cell-template="cellTemplate" edit-cell-template="editCellTemplate">
                                    <DxRequiredRule />
                                  </DxColumn>
                                  <template #cellTemplate="{ data }">
                                    <a v-if="data.value" :href="data.value" target="_blank">{{ $t('registration.viewFile') }}</a>
                                  </template>
                                  <template #editCellTemplate="{ data }">
                                    <div>
                                      <div v-if="data.value" class="current-file-container">
                                        {{ $t('registration.currentFile') }}: <a :href="data.value" target="_blank">{{ getFileName(data.value) }}</a>
                                      </div>
                                      <div class="fileuploader-container">
                                        <DxFileUploader :ref="fileUploaderRef" :multiple="false" accept=".pdf" upload-mode="instantly" :upload-url="backendURL + '/Api/Upload'" name="formFiles" :upload-headers="uploadHeaders" @uploaded="(e) => onUploaded(e, data)" @upload-error="onUploadError" />
                                      </div>
                                    </div>
                                  </template>
                                  <DxGroupPanel :visible="true" />
                                </DxDataGrid>
                              </template>
                            </DxSimpleItem>
                          </DxGroupItem>
                          <DxGroupItem :col-count="4" css-class="title-with-line" :caption="$t('registration.secondaryContact')">
                            <DxSimpleItem data-field="sec_Name">
                              <dx-label :text="$t('registration.name')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sec_Title">
                              <dx-label :text="$t('registration.title')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sec_Position">
                              <dx-label :text="$t('registration.position')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sec_Phone" editor-type="dxTextBox" :editor-options="phoneOptions">
                              <dx-label :text="$t('registration.secondaryPhone')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sec_Ext">
                              <dx-label :text="$t('registration.ext')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sec_Phone_Type_Id" :label="{ text: $t('registration.phoneType') }" editor-type="dxSelectBox" :editor-options="{
                              dataSource: PhoneTypeOptionsTwo,
                              displayExpr: 'Name',
                              valueExpr: 'Id',
                              searchEnabled: true,
                              onValueChanged: handlePhoneTypeTwo
                            }" />
                            <DxSimpleItem data-field="sec_Email_Address">
                              <dx-label :text="$t('registration.emailAddress')" />
                              <dx-email-rule :message="$t('registration.emailInvalid')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sec_Confirm_Email">
                              <dx-label :text="$t('registration.confirmEmail')" />
                              <DxCompareRule :comparison-target="secondaryEmailComparison" :message="$t('registration.emailMismatch')" />
                            </DxSimpleItem>
                          </DxGroupItem>
                          <br><br><br>
                        </PrimaryContactForm>
                      </form>
                    </div>
                    <div slot="page3">
                      <form>
                        <div class="stamps-wrapper">
                          <div v-for="stamp in taxStamps" :key="stamp.id" :id="'stamp-item-' + stamp.id" class="stamp-item" :class="{ 'selected': isSelected(stamp) }">
                            <div class="stamp-content">
                              <DxCheckBox :value="isSelected(stamp)" @value-changed="toggleSelection(stamp, $event)" :text="stamp.name" class="stamp-checkbox" />
                              <!-- <dx-required-rule :message="$t('registration.companyNationalIdRequired')" /> -->
                              <img :src="stamp.imageUrl" :alt="stamp.name" class="stamp-image" />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div slot="page4">
                      <form action="action" @submit.prevent="">
                        <FacilityForm ref="form3" :form-data="formData3" label-mode="floating">
                          <DxGroupItem :caption="$t('registration.facilityDetails')" :col-count="1">
                            <DxSimpleItem name="FacilityDetailsGrid">
                              <template #default>
                                <DxDataGrid ref="FacilityDetailsRef" id="grid-container1" :show-borders="true"
                                  :data-source="FacilityDetailsData" :row-alternation-enabled="true"
                                  :hover-state-enabled="true" @row-inserted="onSaveFacility($event)"
                                  @editor-preparing="onEditorPreparing"
                                  @row-removed="onRemoveFacility($event)" :selection="{ mode: 'multiple' }"
                                  :column-hiding-enabled="true" key-expr="Id">
                                  <DxEditing :allow-deleting="true" :allow-adding="true" mode="form">
                                    <DataForm label-mode="floating" :col-count="2">
                                      <DxItem :col-count="1" itemType="group" :caption="$t('registration.general')">
                                        <DxItem dataField="Facility_Name">
                                          <dx-label :text="$t('registration.facilityName')" />
                                          <dx-required-rule :message="$t('registration.facilityNameRequired')" />
                                        </DxItem>
                                        <DxItem data-field="Facility_Type" :label="{ text: $t('registration.facilityType') }" editor-type="dxSelectBox" :editor-options="{
                                          dataSource: PhoneTypeOptionsTwo,
                                          displayExpr: 'Name',
                                          valueExpr: 'Id',
                                          searchEnabled: true,
                                        }" :validation-rules="[{ type: 'required', message: $t('registration.facilityTypeRequired') }]" />
                                        <DxItem dataField="Address_Line_1">
                                          <dx-label :text="$t('registration.addressLine1')" />
                                          <dx-required-rule :message="$t('registration.addressLine1Required')" />
                                        </DxItem>
                                        <DxItem dataField="Address_Line_2">
                                          <dx-label :text="$t('registration.addressLine2')" />
                                        </DxItem>
                                        <DxItem dataField="Coordinates" editor-type="dxTextBox" :editor-options="coordinatesEditorOptions">
                                          <dx-label :text="$t('registration.coordinates')" />
                                          <!-- <dx-required-rule :message="$t('registration.coordinatesRequired')" /> -->
                                        </DxItem>
                                      </DxItem>
                                      <DxItem :col-count="1" itemType="group" :caption="$t('registration.contact')">
                                        <DxItem dataField="First_Name">
                                          <dx-label :text="$t('registration.firstName')" />
                                          <dx-required-rule :message="$t('registration.firstNameRequired')" />
                                        </DxItem>
                                        <DxItem dataField="Last_Name">
                                          <dx-label :text="$t('registration.lastName')" />
                                          <dx-required-rule :message="$t('registration.lastNameRequired')" />
                                        </DxItem>
                                        <DxItem dataField="Email_Address">
                                          <dx-label :text="$t('registration.emailAddress')" />
                                          <dx-required-rule :message="$t('registration.emailAddressRequired')" />
                                          <dx-email-rule :message="$t('registration.emailInvalid')" />
                                        </DxItem>
                                        <DxItem dataField="Phone_No" ditor-type="dxTextBox" :editor-options="phoneOptions">
                                          <dx-required-rule :message="$t('registration.phoneNumberRequired')" />
                                          <dx-label :text="$t('registration.phoneNumber')" />
                                        </DxItem>
                                      </DxItem>
                                    </DataForm>
                                  </DxEditing>
                                  <DxColumn data-field="Facility_Name" />
                                  <DxColumn data-field="Facility_Type" />
                                  <DxColumn data-field="Address_Line_1" :visible="false" />
                                  <DxColumn data-field="Address_Line_2" :visible="false" />
                                  <DxColumn data-field="Coordinates" :visible="true" :caption="$t('registration.coordinates')" />
                                  <DxColumn data-field="First_Name" :visible="false" />
                                  <DxColumn data-field="Last_Name" :visible="false" />
                                  <DxColumn data-field="Email_Address" :visible="false" />
                                  <DxColumn data-field="Phone_No" :visible="false" />
                                  <DxColumnFixing :enabled="true" />
                                  <DxGroupPanel :visible="true" />
                                  <DxSelection mode="multiple" />
                                </DxDataGrid>
                              </template>
                            </DxSimpleItem>
                          </DxGroupItem>
                          <br><br>
                        </FacilityForm>
                      </form>
                    </div>
                    <div slot="page5">
                      <form action="action" @submit.prevent="">
                        <UIMForecastForm ref="form4" :form-data="formData4" label-mode="floating">
                          <DxGroupItem :col-count="2" css-class="first-group" :caption="$t('registration.version')">
                            <DxSimpleItem data-field="Version" :validation-rules="NumberValidationRules">
                              <dx-label :text="$t('registration.version')" />
                            </DxSimpleItem>
                          </DxGroupItem>
                          <DxGroupItem :col-count="2" css-class="first-group" :caption="$t('registration.general')">
                            <DxSimpleItem data-field="Year" :validation-rules="NumberValidationRules" editor-type="dxSelectBox" :editor-options="yearEditorOptions">
                              <dx-label :text="$t('registration.year')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="Quarter" :validation-rules="NumberValidationRules" editor-type="dxSelectBox" :editor-options="quarterEditorOptions">
                              <dx-label :text="$t('registration.quarter')" />
                            </DxSimpleItem>
                          </DxGroupItem>
                          <DxGroupItem :caption="$t('registration.uimForecast')" :col-count="1">
                            <DxSimpleItem name="UIMForecastGrid">
                              <template #default>
                                <DxDataGrid ref="UIMForecastRef" id="grid-container1" :show-borders="true"
                                  :data-source="UIMForecastData" :row-alternation-enabled="true"
                                  @saved="onRowSaved($event)"
                                  :hover-state-enabled="true" :selection="{ mode: 'multiple' }"
                                  :column-hiding-enabled="true" key-expr="Id">
                                  <DxEditing :allow-deleting="true" :allow-adding="true" mode="form"/>
                                  <DxColumn data-field="Product_Id" :caption="$t('registration.product')">
                                    <DxLookup :data-source="taxStamps" value-expr="id" display-expr="name" />
                                    <DxRequiredRule />
                                  </DxColumn>
                                  <DxColumn data-field="Month" :caption="$t('registration.month')">
                                    <DxLookup :data-source="FilteredMonthOptions" value-expr="Id" display-expr="Name" />
                                    <DxRequiredRule />
                                  </DxColumn>
                                  <DxColumn data-field="UIMForecast">
                                    <DxFormItem editor-type="dxNumberBox" />
                                    <DxRequiredRule />
                                  </DxColumn>
                                  <DxColumnFixing :enabled="false" />
                                  <DxGroupPanel :visible="true" />
                                  <DxSelection mode="multiple" />
                                </DxDataGrid>
                              </template>
                            </DxSimpleItem>
                          </DxGroupItem>
                          <DxGroupItem :col-count="2" css-class="first-group" :caption="$t('registration.totalForecast')">
                            <DxSimpleItem data-field="TotalForecast" :validation-rules="NumberValidationRules"
                            :editor-options="{ readOnly: true, format: '#,##0.##' }">
                              <dx-label :text="$t('registration.totalForecast')" />
                            </DxSimpleItem>
                          </DxGroupItem>
                          <br><br>
                        </UIMForecastForm>
                      </form>
                    </div>
                    <div slot="page6">
                      <form class="" @submit.prevent="onSubmit" :disabled="loading">
                        <ReviewAndSubmitForm ref="form5" :form-data="formData5" label-mode="floating">
                          <DxGroupItem :col-count="2" css-class="title-with-line" :caption="$t('registration.organizationDetails')">
                            <DxSimpleItem data-field="organization_Name" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.organizationName')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="company_Registration_No" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.companyRegistrationNo')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="company_National_Identification" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.companyNationalId')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="sales_Tax_No" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.salesTaxNo')" />
                            </DxSimpleItem>
                          </DxGroupItem>
                          <DxGroupItem :col-count="3" css-class="title-with-line" :caption="$t('registration.administratorDetails')">
                            <DxSimpleItem data-field="pr_First_Name" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.firstName')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Email_Address" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.emailAddress')" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="pr_Phone" :editor-options="{ readOnly: true }">
                              <dx-label :text="$t('registration.primaryPhone')" />
                            </DxSimpleItem>
                          </DxGroupItem>
                          <DxGroupItem :col-count="2" css-class="title-with-line" :caption="$t('registration.accountDetails')">
                            <dx-item data-field='Password' editor-type='dxTextBox' :editor-options="{ mode: 'password' }">
                              <dx-required-rule :message="$t('registration.passwordRequired')" />
                              <dx-label :text="$t('registration.password')" />
                            </dx-item>
                            <dx-item data-field='Confirm_Password' editor-type='dxTextBox' :editor-options="{ mode: 'password' }">
                              <dx-required-rule :message="$t('registration.confirmPasswordRequired')" />
                              <dx-label :text="$t('registration.confirmPassword')" />
                              <DxCompareRule :comparison-target="passwordComparison" :message="$t('registration.passwordMismatch')" />
                            </dx-item>
                          </DxGroupItem>
                        </ReviewAndSubmitForm>
                      </form>
                    </div>
                  </vue-good-wizard>
                </div>
              </div>
            </div>
          </div>
          <br><br>
          <div class="position-absolute pos-bottom pos-left pos-right p-3 text-center">
            <a href='#' class='opacity-40 fw-500' title='#' target='_blank' style="color:black;">2025 © {{ $t('common.drc') }} {{ $t('common.ministry') }}</a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Location Map Modal -->
    <LocationMapModal
      :visible="showLocationModal"
      :initial-location="currentLocation"
      @location-selected="onLocationSelected"
      @close="closeLocationModal"
    />
  </div>
</template>

<script>
import router from '@/router'
import {
  DxSimpleItem,
  DxGroupItem,
  DxButtonItem,
  DxEmailRule,
  DxRequiredRule,
  DxCompareRule,
  DxLabel,
} from 'devextreme-vue/form'
import { DxTextArea } from 'devextreme-vue/text-area'
import DxLoadIndicator from "devextreme-vue/load-indicator"
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxForm as OrganizationDetailsForm } from 'devextreme-vue/form'
import { DxForm as PrimaryContactForm } from 'devextreme-vue/form'
import { DxForm as ProductSelectionForm } from 'devextreme-vue/form'
import { DxForm as UIMForecastForm } from 'devextreme-vue/form'
import { DxForm as FacilityForm } from 'devextreme-vue/form'
import { DxForm as ReviewAndSubmitForm } from 'devextreme-vue/form'
import { DxForm as DataForm } from 'devextreme-vue/data-grid'
import DxFileUploader from 'devextreme-vue/file-uploader'
import { DxCheckBox } from 'devextreme-vue/check-box'
import { DxItem } from 'devextreme-vue/form'
import { DxLoadPanel } from 'devextreme-vue/load-panel'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import LocationMapModal from '@/components/LocationMapModal.vue'
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxToolbar,
  DxFormItem,
  DxLookup,
  DxGrouping,
  DxSummary,
  DxButton,
  DxMasterDetail,
  DxColumnChooser,
  DxColumnFixing,
  DxGroupPanel,
  DxFilterRow,
  DxSearchPanel,
  DxSelection,
  DxExport,
} from 'devextreme-vue/data-grid'
import { mapActions, mapState } from 'vuex'
import {
  GET_ADMIN_AREA, REGISTER,
  POST_ORGANIZATION_DETAILS, POST_ADMINISTRATOR_DETAILS,
  POST_PRODUCT_SELECTION, POST_FACILITY_DETAILS, POST_UIM_FORECAST,
  POST_ORGANIZATION_DOCUMENT, GET_MFG_PRODUCT, GET_MFG_PRODUCT_TYPE,
  POST_FACILITY_DETAIL_REGISTER, POST_REVIEW_AND_SUBMIT
} from "@/store/_actiontypes"
import constants from '@/helpers/constants'

const fileUploaderRef = 'fu'

export default {
  middleware: 'checkRegDetails',
  components: {
    DxTextArea,
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLoadIndicator,
    DxSelectBox,
    DxRequiredRule,
    DxEmailRule,
    DxCompareRule,
    DxLabel,
    LocationMapModal,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxFormItem,
    DxLookup,
    DxGrouping,
    DxGroupPanel,
    DxSummary,
    DxButton,
    DxMasterDetail,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxSearchPanel,
    DxSelection,
    DxExport,
    DxItem,
    DxCheckBox,
    DxFileUploader,
    OrganizationDetailsForm,
    PrimaryContactForm,
    ProductSelectionForm,
    UIMForecastForm,
    FacilityForm,
    ReviewAndSubmitForm,
    DataForm,
    DxLoadPanel,
    LanguageSwitcher,
  },
  data() {
    const region = []
    return {
      selectedLanguage: 'French',
      loading: true,
      formData0: {},
      formData1: {},
      formData2: {},
      formData3: {},
      formData4: {
        TotalForecast: 0,
        Year: new Date().getFullYear(),
        Quarter: null
      },
      formData5: {},
      formData6: {},
      OrganizationDocumentsData: [],
      FacilityDetailsReqData: [],
      FacilityDetailsData: [],
      UIMForecastData: [],
      regionOptions: [],
      districtOptions: [],
      streetOptions: [],
      shehiaOptions: [],
      OrganizationDetailsResponseData: {},
      fileUploaderRef,
      filePath: "",
      uploadHeaders: {},
      backendURL: constants.BACKEND_UPLOAD_URL,
      taxStamps: [],
      selectedStampIds: new Set(),
      passwordVisibility: false,
      passwordOptions: { visible: true, mode: 'password' },
      isCapturingLocation: false,
      showLocationModal: false,
      currentLocation: null,
      editorOptions: { disabled: false },
      birthDateOptions: { width: '100%', disabled: false },
      phoneOptions: { mask: '+243 000 000 000', disabled: false },
      notesOptions: { height: 140, disabled: true },
    }
  },
  computed: {
    NumberValidationRules() {
      return [
        { type: 'required', message: this.$t('registration.yearRequired') },
        { type: 'pattern', pattern: /^[0-9]+$/, message: this.$t('registration.yearRequired') }
      ]
    },
    steps() {
      return [
        { label: this.$t('registration.steps.organizationDetails'), slot: 'page1' },
        { label: this.$t('registration.steps.administratorDetails'), slot: 'page2' },
        { label: this.$t('registration.steps.productSelection'), slot: 'page3' },
        { label: this.$t('registration.steps.facilityDetails'), slot: 'page4' },
        { label: this.$t('registration.steps.uimForecast'), slot: 'page5' },
        { label: this.$t('registration.steps.reviewAndSubmit'), slot: 'page6' }
      ]
    },
    DocTypeOptions() {
      return [
        { Id: "1", Name: this.$t('documentTypes.nationalId') },
        { Id: "2", Name: this.$t('documentTypes.registrationNumber') },
        { Id: "3", Name: this.$t('documentTypes.salesTaxNumber') },
        { Id: "4", Name: this.$t('documentTypes.other') }
      ]
    },
    OrganizationTypeOptions() {
      return [{ Id: "1", Name: this.$t('organizationTypes.fabricant') }]
    },
    CompanyOccCertificationOptions() {
      return [
        { Id: "Yes", Name: this.$t('certificationOptions.yes') },
        { Id: "No", Name: this.$t('certificationOptions.no') }
      ]
    },
    MFGProductTypeOptions() {
      return [{ Id: "1", Name: this.$t('productTypes.beverages') }]
    },
    PhoneTypeOptions() {
      return [
        { Id: "Mobile", Name: this.$t('phoneTypes.mobile') },
        { Id: "Office", Name: this.$t('phoneTypes.office') }
      ]
    },
    PhoneTypeOptionsTwo() {
      return [
        { Id: "Mobile", Name: this.$t('phoneTypes.mobile') },
        { Id: "Office", Name: this.$t('phoneTypes.office') }
      ]
    },
    MonthOptions() {
      return [
        { Id: "1", Name: this.$t('months.january') },
        { Id: "2", Name: this.$t('months.february') },
        { Id: "3", Name: this.$t('months.march') },
        { Id: "4", Name: this.$t('months.april') },
        { Id: "5", Name: this.$t('months.may') },
        { Id: "6", Name: this.$t('months.june') },
        { Id: "7", Name: this.$t('months.july') },
        { Id: "8", Name: this.$t('months.august') },
        { Id: "9", Name: this.$t('months.september') },
        { Id: "10", Name: this.$t('months.october') },
        { Id: "11", Name: this.$t('months.november') },
        { Id: "12", Name: this.$t('months.december') }
      ]
    },
    YearOptions() {
      const currentYear = new Date().getFullYear();
      return [
        { Id: currentYear, Name: currentYear.toString() },
        { Id: currentYear + 1, Name: (currentYear + 1).toString() }
      ];
    },
    QuarterOptions() {
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      if (this.formData4.Year === currentYear) {
        const quarters = [];
        if (currentMonth < 4) {
          quarters.push(
            { Id: 1, Name: 'Quarter 1' },
            { Id: 2, Name: 'Quarter 2' },
            { Id: 3, Name: 'Quarter 3' },
            { Id: 4, Name: 'Quarter 4' }
          );
        } else if (currentMonth < 7) {
          quarters.push(
            { Id: 2, Name: 'Quarter 2' },
            { Id: 3, Name: 'Quarter 3' },
            { Id: 4, Name: 'Quarter 4' }
          );
        } else if (currentMonth < 10) {
          quarters.push({ Id: 4, Name: 'Quarter 4' });
        } else {
          quarters.push({ Id: 4, Name: 'Quarter 4' });
        }
        return quarters;
      }
      return [
        { Id: 1, Name: 'Quarter 1' },
        { Id: 2, Name: 'Quarter 2' },
        { Id: 3, Name: 'Quarter 3' },
        { Id: 4, Name: 'Quarter 4' }
      ];
    },
    FilteredMonthOptions() {
      if (!this.formData4.Quarter) {
        return this.MonthOptions;
      }
      const quarterStartMonth = (this.formData4.Quarter - 1) * 3 + 1;
      const quarterEndMonth = this.formData4.Quarter * 3;
      return this.MonthOptions.filter(month => {
        const monthNum = parseInt(month.Id);
        return monthNum >= quarterStartMonth && monthNum <= quarterEndMonth;
      });
    },
    yearEditorOptions() {
      return {
        dataSource: this.YearOptions,
        valueExpr: 'Id',
        displayExpr: 'Name',
        onValueChanged: this.onYearChanged
      };
    },
    quarterEditorOptions() {
      return {
        dataSource: this.QuarterOptions,
        valueExpr: 'Id',
        displayExpr: 'Name',
        onValueChanged: this.onQuarterChanged
      };
    },
    coordinatesEditorOptions() {
      return {
        readOnly: true,
        placeholder: "Click 'Select Location' to capture coordinates",
        //value: '',
        onValueChanged: (e) => {
          console.log('Coordinates field value changed:', e);
          //return e.value
        },
        buttons: [{
          name: 'getLocation',
          location: 'after',
          options: {
            icon: 'map',
            text: 'SELECT LOCATION',
            type: 'default',
            disabled: false,
            elementAttr: { class: 'dx-button-has-text' },
          }
        }]
      };
    },
    buttonOptions() {
      return {
        text: this.$t('common.next'),
        type: 'default',
        useSubmitBehavior: true,
      }
    },
    checkBoxOptions() {
      return {
        text: this.$t('registration.iAmForeigner'),
        onValueChanged: (e) => {
          this.passwordVisibility = e.component.option('value');
          this.formData.Foreigner = e.component.option('value');
        },
      }
    }
  },
  props: {
  componentsCountChanged: {
    type: Function,
    required: false,
  },},
  beforeDestroy() {
  if (typeof this.componentsCountChanged === 'function') {
    this.componentsCountChanged();
  }},
  created() {
    this.loadMfgProductData();
    this.setInitialQuarter();
  },
  methods: {
    ...mapActions("application", [
      GET_ADMIN_AREA,
      POST_ORGANIZATION_DETAILS,
      POST_ADMINISTRATOR_DETAILS,
      POST_PRODUCT_SELECTION,
      POST_FACILITY_DETAILS,
      POST_UIM_FORECAST,
      POST_ORGANIZATION_DOCUMENT,
      GET_MFG_PRODUCT,
      GET_MFG_PRODUCT_TYPE,
      POST_FACILITY_DETAIL_REGISTER,
      POST_REVIEW_AND_SUBMIT
    ]),
    ...mapActions("user", [REGISTER]),
    setLanguage(lang) {
      this.selectedLanguage = lang;
      console.log(`Language changed to ${lang}`);
    },
    nextClicked(currentPage) {
      const _this = this;
      switch (currentPage) {
        case 0:
          const isFormValid0 = this.$refs.form0?.instance.validate().isValid ?? false;
          if (isFormValid0) {
            this.POST_ORGANIZATION_DETAILS(this.formData0)
              .then(res => {
                this.OrganizationDetailsResponseData = res?.data?.data
                _this.$refs.wizard.goNext(true);
              })
              .catch(error => {
                console.log(error);
                _this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
              });
            return false;
          }
          return false;
        case 1:
          const isFormValid1 = this.$refs.form1?.instance.validate().isValid ?? false;
          if (isFormValid1) {
            this.formData1.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
            this.POST_ADMINISTRATOR_DETAILS(this.formData1)
              .then(res => {
                _this.$refs.wizard.goNext(true);
              })
              .catch(error => {
                console.log(error);
                _this.$toast.error(error?.data?.errors?.message || "Oops! Something went wrong");
              });
            return false;
          }
          return false;
        case 2:
          const isValid2 = this.selectedStampIds.size != 0;
          if (isValid2) {
            let payload = {
              entity_Id: this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id,
              product_Ids: [...this.selectedStampIds]
            }
            this.POST_PRODUCT_SELECTION(payload)
              .then(res => {
                _this.$refs.wizard.goNext(true);
              })
              .catch(error => {
                console.log(error);
                this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
              });
            return false;
          }
          return false;
        case 3:
          const isFormValid3 = this.FacilityDetailsData.length != 0;
          if (isFormValid3) {
            let payload = {
              entity_Id: this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id,
              facilityDetails: this.FacilityDetailsData
            }
            this.POST_FACILITY_DETAIL_REGISTER(payload)
              .then(res => {
                _this.$refs.wizard.goNext(true);
              })
              .catch(error => {
                console.log(error);
                _this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
              });
            return false;
          }
          return false;
        case 4:
          const isFormValid4 = this.$refs.form4?.instance.validate().isValid ?? false;
          if (isFormValid4) {
            let payload = {
              entity_Id: this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id,
              details: this.UIMForecastData
            }
            let _payload = { ...payload, ...this.formData4 };
            this.POST_UIM_FORECAST(_payload)
              .then(res => {
                this.formData5 = {
                  organization_Name: res?.data?.data?.organization_Details?.organization_Name,
                  company_Registration_No: res?.data?.data?.organization_Details?.company_Registration_No,
                  company_National_Identification: res?.data?.data?.organization_Details?.company_National_Identification,
                  sales_Tax_No: res?.data?.data?.organization_Details?.sales_Tax_No,
                  pr_First_Name: res?.data?.data?.admistration_Details?.pr_First_Name,
                  pr_Email_Address: res?.data?.data?.admistration_Details?.pr_Email_Address,
                  pr_Phone: res?.data?.data?.admistration_Details?.pr_Phone,
                  sales_Tax_No: res?.data?.data?.admistration_Details?.sales_Tax_No,
                  Password: "",
                  Confirm_Password: ""
                };
                _this.$refs.wizard.goNext(true);
              })
              .catch(error => {
                console.log(error);
                _this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
              });
            return false;
          }
          return false;
        case 5:
          const isFormValid5 = this.$refs.form5?.instance.validate().isValid ?? false;
          if (isFormValid5) {
            this.formData5.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id;
            this.POST_REVIEW_AND_SUBMIT(this.formData5)
              .then(res => {
                this.$toast.success(this.$t('registration.stakeholderRegistered'))
                router.push({ path: '/login' })
              })
              .catch(error => {
                console.log(error);
                _this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
              });
            return false;
          }
          return false;
        default:
          return true;
      }
    },
    backClicked(currentPage) {
      switch (currentPage) {
        case 1:
          this.formData0.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
        case 2:
          this.formData1._Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
          this.formData1.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
        case 3:
          this.formData2._Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
          this.formData2.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
        case 4:
          this.formData3._Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
          this.formData3.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
        case 5:
          this.formData4._Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
          this.formData4.entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
        default:
          return true;
      }
    },
    toggleSelection(stamp, e) {
      if (e.value) {
        this.selectedStampIds.add(stamp.id);
        console.log("Stamp added:", Array.from(this.selectedStampIds));
      } else {
        this.selectedStampIds.delete(stamp.id);
        console.log("Stamp removed:", Array.from(this.selectedStampIds));
      }
      this.$emit('selection-changed', Array.from(this.selectedStampIds));
    },
    isSelected(stamp) {
      console.log('isSelected called with stamp:', stamp);
      return this.selectedStampIds.has(stamp.id);
    },
    onSaveDocument(event) {
      let payload = event.data
      payload.IsNew = true
      payload.Entity_Id = this.OrganizationDetailsResponseData?.cmm_Entity_Particular?.id
      this.POST_ORGANIZATION_DOCUMENT(payload).then(res => {
        //this.OrganizationDocumentsData = []
        //this.loadData()
        //this.$toast.success("Document saved successfully!")
      })
      .catch(error => {
        console.log(error)
      })
    },
    onSaveFacility(event) {
      // const newFacility = {
      //   ...event.data,
      //   Id: event.data.Id || Date.now(),
      //   Coordinates: event.data.Coordinates || ''
      // };
      // this.FacilityDetailsData.push(newFacility);
      // console.log('Facility saved:', newFacility);
    },
    onRemoveFacility(event) {
      this.FacilityDetailsData = this.FacilityDetailsData.filter(item => item.Id !== event.data.Id);
      console.log('Facility removed:', event.data.Id);
    },
    getFileName(url) {
      if (!url) return '';
      return url.substring(url.lastIndexOf('/') + 1);
    },
    onUpdateStart(e) {
      this.filePath = e.data.File
    },
    onUploaded(e, cellInfo) {
      let res = JSON.parse(e.request.response)
      cellInfo.setValue(res.fileUrl);
      this.filePath = res.fileUrl;
      this.retryButtonVisible = false;
    },
    onUploadError(e) {
      let xhttp = e.request;
      if (xhttp.status === 400) {
        e.message = e.error.responseText;
      }
      if (xhttp.readyState === 4 && xhttp.status === 0) {
        e.message = this.$t('errors.connectionRefused');
      }
      this.retryButtonVisible = true;
    },
    handleCompanyOccCertificationOptions() {},
    handleOrganizationType() {},
    handleMFGProductType() {},
    handlePhoneType() {},
    handlePhoneTypeTwo() {},
    handleCompanyOccCertification() {},
    loadMfgProductData() {
      this.GET_MFG_PRODUCT().then(res => {
        this.taxStamps = res.data.map((item, index) => {
          return {
            id: item.id,
            name: item.source_Name,
            imageUrl: "https://atx-transact-demo-drc-api.azurewebsites.net/content/Images/stamps/reel_30k_domestic.png"
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
    },
    disableButton(value) {
      return this.buttonOptions = {
        text: this.$t('common.submit'),
        type: 'default',
        useSubmitBehavior: true,
        disabled: value
      }
    },
    onRowSaved(e) {
        const totalUIMForecast = this.UIMForecastData.reduce((sum, item) => sum + Number(item.UIMForecast), 0);
        this.formData4.TotalForecast = Number(totalUIMForecast);
    }, 
    setInput() {
      this.formData.Nat_Id = this.regData.address
      this.formData.Mobile_Phone = this.regData.phone_Number
    },
    handleRegionChange(e) {
      this.formData.Region = e.value
    },
    handleDistrictChange(e) {
      this.formData.District = e.value
    },
    handleStreetChange(e) {
      this.formData.Street = e.value
    },
    handleShehiaChange(e) {
      this.formData.Admin_Area_Id = e.value
    },
    passwordComparison() {
      return this.formData5.Password
    },
    primaryEmailComparison() {
      return this.formData1.pr_Email_Address
    },
    secondaryEmailComparison() {
      return this.formData1.sec_Email_Address
    },
    checkComparison() {
      return true
    },
    getCoordinatesDisplay(coordinates) {
      if (!coordinates) return '';
      if (typeof coordinates === 'string') {
        try {
          const coords = JSON.parse(coordinates);
          return `${coords.latitude}, ${coords.longitude}`;
        } catch (e) {
          return coordinates;
        }
      }
      if (coordinates.latitude && coordinates.longitude) {
        return `${coordinates.latitude}, ${coords.longitude}`;
      }
      return coordinates;
    },
    async captureCurrentLocationForForm() {
      this.isCapturingLocation = true;
      try {
        if (!navigator.geolocation) {
          throw new Error('Geolocation is not supported by this browser');
        }
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 60000
          });
        });
        const coordinates = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          timestamp: position.timestamp
        };
        const coordinatesString = JSON.stringify(coordinates);
        if (this.$refs.FacilityDetailsRef && this.$refs.FacilityDetailsRef.instance) {
        console.log(this.$refs.FacilityDetailsRef.instance);
          const editingRowKey = this.$refs.FacilityDetailsRef.instance.option('editing.editRowKey');
          if (editingRowKey !== null) {
            //this.$refs.FacilityDetailsRef.instance.cellValue(editingRowKey, 'Coordinates', coordinatesString);
          }
        }
        this.$toast.success('Location captured successfully!');
      } catch (error) {
        console.error('Error capturing location:', error);
        let errorMessage = 'Failed to capture location';
        if (error.code === 1) {
          errorMessage = 'Location access denied. Please allow location access and try again.';
        } else if (error.code === 2) {
          errorMessage = 'Location unavailable. Please check your device location settings.';
        } else if (error.code === 3) {
          errorMessage = 'Location request timed out. Please try again.';
        }
        this.$toast.error(errorMessage);
      } finally {
        this.isCapturingLocation = false;
      }
    },
    openLocationModal(editingRowKey) {
      this.showLocationModal = true;
      this.editingRowKey = editingRowKey; 
      //console.log('Editing row key: CUSTOM ', this.editingRowKey);  
    },
    closeLocationModal() {
      this.showLocationModal = false;
    },
    onLocationSelected(location) {
      console.log('Location selected:', location);
      if (this.$refs.FacilityDetailsRef && this.$refs.FacilityDetailsRef.instance) {
        const gridInstance = this.$refs.FacilityDetailsRef.instance;
        //const editingRowKey = gridInstance.option('editing.editRowKey');
        //const editingRowKey_ = gridInstance.columnOption();
        //console.log(editingRowKey_);
        console.log('Editing row key:', this.editingRowKey);

        //this.dataGrid.cellValue(3, 'Coordinates', value);

        if (this.editingRowKey !== null) {
          const coordinatesString = JSON.stringify({
            latitude: location.latitude,
            longitude: location.longitude,
            accuracy: location.accuracy,
            timestamp: location.timestamp
          });
          console.log('Setting coordinates:', coordinatesString);

          // Use the cellValue method to programmatically set the value.
          // This is the correct and only required step.
          gridInstance.cellValue(this.editingRowKey, 'Coordinates', coordinatesString);
          
          console.log('Cell value set successfully.');
        } else {
          console.warn('No row is currently being edited');
        }
      } else {
        console.error('FacilityDetailsRef not found');
      }
      // Close the modal after setting the value
      this.closeLocationModal();
    },
    onEditorPreparing(e) {
      console.log('onEditorPreparing called:', e);
      // Check if the current editor is for the 'Coordinates' field and it's in a data row
      if (e.dataField === 'Coordinates' && e.parentType === 'dataRow') {
        const gridInstance = e.component;
        const rowIndex = e.row.rowIndex;
        // Find the "SELECT LOCATION" button and modify its onClick handler
        const button = e.editorOptions.buttons.find(btn => btn.name === 'getLocation');

        if (button) {
          button.options.onClick = () => {
            console.log(`Location button clicked for row index: ${rowIndex}`);
            
            // Open the modal and pass the current row's key
            this.openLocationModal(rowIndex);
          };
        }
      }
    },
    setInitialQuarter() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      if (currentMonth < 4) {
        this.formData4.Quarter = 1;
      } else if (currentMonth < 7) {
        this.formData4.Quarter = 2;
      } else if (currentMonth < 10) {
        this.formData4.Quarter = 4;
      } else {
        this.formData4.Quarter = 4;
      }
    },
    onYearChanged(e) {
      this.formData4.Year = e.value;
      this.formData4.Quarter = null;
      if (this.formData4.Year === new Date().getFullYear()) {
        this.setInitialQuarter();
      } else {
        this.formData4.Quarter = 1;
      }
    },
    onQuarterChanged(e) {
      this.formData4.Quarter = e.value;
    },
  },
}

</script>

<style scoped>
.lang-switcher-group {
  display: flex;
  border-radius: 4px;
  overflow: hidden;
}
.lang-btn {
  border: none;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  background-color: #e0e0e0;
  color: #015196;
}
.lang-btn:first-child {
  border-right: 1px solid white;
}
.lang-btn.active {
  background-color: orangered;
  color: white;
}
.btn-link.text-white {
  text-decoration: none;
  font-size: 1rem;
}
.btn-link.text-white:hover {
  text-decoration: underline;
  opacity: 0.9;
}
.tax-stamp-selector-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.stamps-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.stamp-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.coordinates-editor {
  display: flex;
  align-items: center;
  gap: 8px;
}
.coordinates-editor input {
  flex: 1;
  min-width: 200px;
}
.coordinates-editor button {
  white-space: nowrap;
  min-width: 120px;
}
.stamp-item {
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 223px;
  box-sizing: border-box;
  min-height: 250px;
}
.stamp-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.stamp-item.selected {
  border-color: #2c60ec;
  box-shadow: 0 4px 12px rgba(73, 104, 240, 0.3);
}
.stamp-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.stamp-checkbox {
  margin-bottom: 10px;
  text-align: center;
}
.stamp-image {
  width: 158px;
  height: 158px;
  object-fit: contain;
  margin-top: auto;
  margin-bottom: auto;
}
h3 {
  margin-top: 0;
  margin-bottom: 20px;
  font-weight: 400;
  color: #555;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
#gridContainer {
  min-height: 530px;
  width: 1000px;
}
.buttonClear {
  margin-left: 7px;
}
.current-file-container {
  margin-bottom: 10px;
}
</style>